import * as React from "react";
import { motion, useCycle, AnimatePresence } from "framer-motion";
import { MenuToggle } from "./Toggle";
import { Navigation } from "./Navigation";
import { Link } from "react-router-dom";
import Orari from "./Orari";
import logo from "../images/home/logoBar.png";
import logoNuovo from "../images/home/Logo_nuovo_ilCigno_white-01.png"
import "./StyleHamburger.css";

// Define sidebar animation properties
const sidebar = {
    open: {
        opacity: 1,
        transition: { duration: 0.3 },
    },
    closed: {
        opacity: 0,
        transition: { duration: 0.3 },
    },
};

// Define collapse animation properties
const collapseVariants = {
    open: {
        opacity: 1,
        height: "auto",
        transition: { duration: 0.5, ease: "easeOut" },
    },
    closed: {
        opacity: 0,
        height: 0,
        transition: { duration: 0.3, ease: "easeIn" },
    },
};

// Overlay animation properties
const overlayVariants = {
    open: {
        opacity: 0.5,
        pointerEvents: "auto" as "auto",  // Specifichiamo il tipo corretto
        transition: { duration: 0.3 },
    },
    closed: {
        opacity: 0,
        pointerEvents: "none" as "none",  // Specifichiamo il tipo corretto
        transition: { duration: 0.3 },
    },
};


function Bar_3() {
    const [isOpen, toggleOpen] = useCycle(false, true);
    const [isOrariOpen, setIsOrariOpen] = React.useState(false);

    // Toggle function for Orari section
    const toggleOrari = () => {
        setIsOrariOpen(prevState => !prevState);
    };

    // Effect to disable page scroll when menu is open
    React.useEffect(() => {
        document.body.classList.toggle("no-scroll", isOpen);
        return () => document.body.classList.remove("no-scroll");
    }, [isOpen]);

    return (
        <div>
            <nav className={`navbar navbar-expand-xxl fixed-top ${isOpen ? "overlay-navbar" : ""}`}
                 style={{ backgroundColor: "#2F719D", height: "5em" }}>
                <div className="container-fluid">
                    <Link className="navbar-brand text-white align-items-center" to="/">
                        <img className="nav-item-logo" src={logoNuovo} alt="IL CIGNO" style={{ width: "150px", marginLeft: "1em" }} />
                    </Link>
                    <motion.nav
                        className={`hamburg-nav ${isOpen ? "open" : ""}`}
                        initial={false}
                        animate={isOpen ? "open" : "closed"}
                    >
                        <motion.div className="navbar hamburg-nav" variants={sidebar} />
                        <br/>
                        <br/>
                        <Navigation toggleOpen={toggleOpen} toggleOrari={toggleOrari} />
                        <MenuToggle toggle={() => toggleOpen()} />
                    </motion.nav>
                </div>
            </nav>

            {/* Overlay to darken background */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="overlay"
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={overlayVariants}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "black",
                            zIndex: 999, // Overlay below the menu and navbar
                        }}
                        onClick={() => toggleOpen()} // Close menu on overlay click
                    />
                )}
            </AnimatePresence>

            {/* Animated Orari Collapse with AnimatePresence */}
            <AnimatePresence>
                {isOrariOpen && (
                    <motion.div
                        className="collapse show"
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={collapseVariants}
                        style={{ overflow: "hidden" }}
                    >
                        <div className="card card-body" style={{ border: "none", position: "relative" }}>
                            <div
                                className="nav-link active d-xxl-none text-black"
                                onClick={toggleOrari}
                                style={{ position: "absolute", top: "7em", right: "27px" }}
                            >
                                <i className="bi-x-lg" style={{ cursor: "pointer", color: "black", fontSize: "22px" }}></i>
                            </div>
                            <Orari />
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default Bar_3;
